import axios from 'axios';
import { GET_LOGINLOGS, LOGINLOGS_LOADING, CLEAR_LOGINLOGS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { ILoginLog } from '../../types/interfaces';

export const getLoginlogs = (duration: any) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: LOGINLOGS_LOADING
  });
  axios
    .get('/api/loginlogs', {...tokenConfig(getState), params: {duration}})
    .then(res =>
      dispatch({
        type: GET_LOGINLOGS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setLoginlogsLoading = () => {
  return {
    type: LOGINLOGS_LOADING
  };
};

export const clearLoginlogs = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_LOGINLOGS
  })
};